/** Shared types + mock rows for allenatore dashboard (until API lands). */

export interface ConvocationRowItem {
    id: string;
    title: string;
    description: string;
    status: string;
    date: string;
    location: string;
    address: string;
    city: string;
    province: string;
    linkPosition: string;
    categoryName?: string;
    /** Id categoria (anagrafia società) per caricare i convocati da `/categories/users`. */
    categoryId?: string;
    invitedCount?: number;
    /** Id atleti convocati (come in DB `c_convocations.users` JSON). */
    users?: string[];
    /** Utente che ha creato la convocazione (allenatore). */
    userId?: string;
}

export interface ConvocatedUserPreview {
    id: string;
    fullName: string;
    roleLabel?: string;
}

export const MISTER_MOCK_CONVOCATED_USERS: ConvocatedUserPreview[] = [
    { id: 'u01', fullName: 'Luca Brambilla', roleLabel: 'Portiere' },
    { id: 'u02', fullName: 'Marco Ferrero', roleLabel: 'Difensore' },
    { id: 'u03', fullName: 'Andrea Galli', roleLabel: 'Difensore' },
    { id: 'u04', fullName: 'Simone Colombo', roleLabel: 'Centrocampista' },
    { id: 'u05', fullName: 'Davide Riva', roleLabel: 'Centrocampista' },
    { id: 'u06', fullName: 'Federico Martini', roleLabel: 'Centrocampista' },
    { id: 'u07', fullName: 'Matteo Leone', roleLabel: 'Attaccante' },
    { id: 'u08', fullName: 'Giuseppe Serra', roleLabel: 'Attaccante' },
    { id: 'u09', fullName: 'Alessandro Fontana', roleLabel: 'Difensore' },
    { id: 'u10', fullName: 'Tommaso Viola', roleLabel: 'Centrocampista' },
    { id: 'u11', fullName: 'Nicola Parini', roleLabel: 'Difensore' },
    { id: 'u12', fullName: 'Stefano Moretti', roleLabel: 'Portiere' },
    { id: 'u13', fullName: 'Riccardo Fumagalli', roleLabel: 'Centrocampista' },
    { id: 'u14', fullName: 'Paolo Basile', roleLabel: 'Attaccante' },
    { id: 'u15', fullName: 'Daniele Costa', roleLabel: 'Difensore' },
    { id: 'u16', fullName: 'Edoardo Pellegrini', roleLabel: 'Centrocampista' },
    { id: 'u17', fullName: 'Christian Monti', roleLabel: 'Attaccante' },
    { id: 'u18', fullName: 'Michele Donati', roleLabel: 'Difensore' },
    { id: 'u19', fullName: 'Filippo Bernardi', roleLabel: 'Centrocampista' },
    { id: 'u20', fullName: 'Gabriele Romano', roleLabel: 'Attaccante' },
    { id: 'u21', fullName: 'Lorenzo Ricci', roleLabel: 'Difensore' },
    { id: 'u22', fullName: 'Valerio De Luca', roleLabel: 'Centrocampista' },
];

export const MISTER_MOCK_CONVOCATIONS: ConvocationRowItem[] = [
    {
        id: 'a1e2f3d4-0001-4000-8000-000000000001',
        title: 'Allenamento tecnico — portieri',
        description:
            'Lavoro su uscite basse e posizionamento. Portare acqua e pettorina.',
        status: 'Pubblicata',
        date: '2026-05-08T18:30:00',
        location: 'Centro Sportivo Aurora',
        address: 'Via dei Tigli 42',
        city: 'Milano',
        province: 'MI',
        linkPosition:
            'https://maps.google.com/?q=Centro+Sportivo+Aurora+Milano',
        categoryName: 'Seniores',
        invitedCount: 14,
    },
    {
        id: 'a1e2f3d4-0002-4000-8000-000000000002',
        title: 'Ripresa post-infortuni',
        description:
            'Seduta leggera per gruppo recupero medico.',
        status: 'Bozza',
        date: '2026-05-06T09:15:00',
        location: 'Palestra comunale',
        address: 'Piazza Garibaldi 3',
        city: 'Monza',
        province: 'MB',
        linkPosition: 'https://maps.google.com/?q=Piazza+Garibaldi+3+Monza',
        categoryName: 'U19',
        invitedCount: 6,
    },
    {
        id: 'a1e2f3d4-0003-4000-8000-000000000003',
        title: 'Partita amichevole vs ASD Brianza',
        description:
            'Convocazione confermata: ritrovo alle 13:45 davanti allo spogliatoio campo 1. ' +
            'Portare kit gara completo, maglia blu disponibile in spogliatoio. Briefing tecnico alle 13:55. ' +
            'Rispettare gli orari: riscaldamento obbligatorio dalle 14:10.',
        status: 'Pubblicata',
        date: '2026-05-10T14:30:00',
        location: 'Campo comunale Nord',
        address: 'Strada Statale 36 km 18',
        city: 'Verano Brianza',
        province: 'MB',
        linkPosition:
            'https://maps.google.com/?q=Campo+Nord+Verano+Brianza',
        categoryName: 'Seniores — Serie D',
        invitedCount: 22,
    },
    {
        id: 'a1e2f3d4-0004-4000-8000-000000000004',
        title: 'Video analisi + tattica',
        description: 'Sala multimediale, portare tablet o quaderno.',
        status: 'Chiusa',
        date: '2026-04-28T20:00:00',
        location: 'Sede societaria',
        address: 'Via Roma 108',
        city: 'Seregno',
        province: 'MB',
        linkPosition: 'Via Roma 108, Seregno MB',
        categoryName: 'Staff tecnico',
        invitedCount: 8,
    },
    {
        id: 'a1e2f3d4-0005-4000-8000-000000000005',
        title: 'Test fisici — Yo-Yo intermittent',
        description:
            'Presentarsi a digiuno leggero. Scarpe da corsa obbligatorie.',
        status: 'Pubblicata',
        date: '2026-05-12T08:00:00',
        location: 'Impianto Atletica “M. Rostagno”',
        address: 'Viale Libertà 55',
        city: 'Lissone',
        province: 'MB',
        linkPosition:
            'https://maps.google.com/?q=Viale+Libert%C3%A0+55+Lissone',
        categoryName: 'U17',
        invitedCount: 18,
    },
    {
        id: 'a1e2f3d4-0006-4000-8000-000000000006',
        title: 'Trasferta — ritrovo pullman',
        description:
            'Puntualità rigorosa. Documento d’identità e borsone numerato.',
        status: 'Pubblicata',
        date: '2026-05-14T06:45:00',
        location: 'Parcheggio stadio',
        address: 'Via delle Betulle 7',
        city: 'Carate Brianza',
        province: 'MB',
        linkPosition: 'Parcheggio stadio Carate Brianza',
        categoryName: 'Seniores',
        invitedCount: 24,
    },
    {
        id: 'a1e2f3d4-0007-4000-8000-000000000007',
        title: 'Seduta atletica — circuito',
        description: 'Portare kit completo e fascia elastica.',
        status: 'Pubblicata',
        date: '2026-05-09T19:00:00',
        location: 'Campo sintetico interno',
        address: 'Via Gramsci 14',
        city: 'Desio',
        province: 'MB',
        linkPosition:
            'https://maps.google.com/?q=Via+Gramsci+14+Desio',
        categoryName: 'U15',
        invitedCount: 16,
    },
    {
        id: 'a1e2f3d4-0008-4000-8000-000000000008',
        title: 'Incontro genitori — categorie giovanili',
        description:
            'Presentazione staff e calendario tornei regionali.',
        status: 'Bozza',
        date: '2026-05-11T18:00:00',
        location: 'Sala riunioni',
        address: 'Via Roma 108',
        city: 'Seregno',
        province: 'MB',
        linkPosition: 'Sala riunioni — sede Seregno',
        categoryName: 'Organizzazione',
        invitedCount: 12,
    },
    {
        id: 'a1e2f3d4-0009-4000-8000-000000000009',
        title: 'Calcio d’inizio — Campionato',
        description:
            'Riscaldamento alle 14:00, match ore 15:00.',
        status: 'Pubblicata',
        date: '2026-05-17T14:00:00',
        location: 'Stadio Comunale',
        address: 'Via Parini 2',
        city: 'Cesano Maderno',
        province: 'MB',
        linkPosition:
            'https://maps.google.com/?q=Stadio+Comunale+Cesano+Maderno',
        categoryName: 'Seniores',
        invitedCount: 20,
    },
    {
        id: 'a1e2f3d4-000a-4000-8000-00000000000a',
        title: 'Allenamento a tema — calci piazzati',
        description: 'Focus su corner e punizioni centrali.',
        status: 'Annullata',
        date: '2026-05-05T18:30:00',
        location: 'Campo B',
        address: 'Via dei Tigli 42',
        city: 'Milano',
        province: 'MI',
        linkPosition:
            'https://maps.google.com/?q=Via+dei+Tigli+42+Milano',
        categoryName: 'U19',
        invitedCount: 0,
    },
];

/** Full squad roster — used as the search pool when adding users to a convocation. */
export const MISTER_MOCK_ALL_ROSTER: ConvocatedUserPreview[] = [
    { id: 'u01', fullName: 'Luca Brambilla', roleLabel: 'Portiere' },
    { id: 'u02', fullName: 'Marco Ferrero', roleLabel: 'Difensore' },
    { id: 'u03', fullName: 'Andrea Galli', roleLabel: 'Difensore' },
    { id: 'u04', fullName: 'Simone Colombo', roleLabel: 'Centrocampista' },
    { id: 'u05', fullName: 'Davide Riva', roleLabel: 'Centrocampista' },
    { id: 'u06', fullName: 'Federico Martini', roleLabel: 'Centrocampista' },
    { id: 'u07', fullName: 'Matteo Leone', roleLabel: 'Attaccante' },
    { id: 'u08', fullName: 'Giuseppe Serra', roleLabel: 'Attaccante' },
    { id: 'u09', fullName: 'Alessandro Fontana', roleLabel: 'Difensore' },
    { id: 'u10', fullName: 'Tommaso Viola', roleLabel: 'Centrocampista' },
    { id: 'u11', fullName: 'Nicola Parini', roleLabel: 'Difensore' },
    { id: 'u12', fullName: 'Stefano Moretti', roleLabel: 'Portiere' },
    { id: 'u13', fullName: 'Riccardo Fumagalli', roleLabel: 'Centrocampista' },
    { id: 'u14', fullName: 'Paolo Basile', roleLabel: 'Attaccante' },
    { id: 'u15', fullName: 'Daniele Costa', roleLabel: 'Difensore' },
    { id: 'u16', fullName: 'Edoardo Pellegrini', roleLabel: 'Centrocampista' },
    { id: 'u17', fullName: 'Christian Monti', roleLabel: 'Attaccante' },
    { id: 'u18', fullName: 'Michele Donati', roleLabel: 'Difensore' },
    { id: 'u19', fullName: 'Filippo Bernardi', roleLabel: 'Centrocampista' },
    { id: 'u20', fullName: 'Gabriele Romano', roleLabel: 'Attaccante' },
    { id: 'u21', fullName: 'Lorenzo Ricci', roleLabel: 'Difensore' },
    { id: 'u22', fullName: 'Valerio De Luca', roleLabel: 'Centrocampista' },
    { id: 'u23', fullName: 'Antonio Mancini', roleLabel: 'Difensore' },
    { id: 'u24', fullName: 'Roberto Esposito', roleLabel: 'Portiere' },
    { id: 'u25', fullName: 'Salvatore Greco', roleLabel: 'Centrocampista' },
    { id: 'u26', fullName: 'Giovanni Bianchi', roleLabel: 'Attaccante' },
    { id: 'u27', fullName: 'Francesco Conti', roleLabel: 'Centrocampista' },
    { id: 'u28', fullName: 'Mario Lombardi', roleLabel: 'Difensore' },
    { id: 'u29', fullName: 'Carlo Marini', roleLabel: 'Attaccante' },
    { id: 'u30', fullName: 'Angelo Ferrari', roleLabel: 'Portiere' },
];

export function isConvocationDraft(status: string | undefined): boolean {
    const key = (status ?? '').toLowerCase();
    return key.includes('bozz') || key === 'draft';
}

export function getMockMisterConvocationById(
    id: string | null
): ConvocationRowItem | undefined {
    if (!id) {
        return undefined;
    }
    return MISTER_MOCK_CONVOCATIONS.find((c) => c.id === id);
}

const DAY_MS = 24 * 60 * 60 * 1000;

/** Calendar-day distance from today, e.g. "Oggi", "Tra 3 giorni", "2 giorni fa". */
export function relativeConvocationDay(
    date: string,
): { label: string; past: boolean } | null {
    const target = new Date(date);
    if (Number.isNaN(target.getTime())) {
        return null;
    }
    const startOfDay = (d: Date) =>
        new Date(d.getFullYear(), d.getMonth(), d.getDate()).getTime();
    const days = Math.round(
        (startOfDay(target) - startOfDay(new Date())) / DAY_MS,
    );
    if (days === 0) {
        return { label: 'Oggi', past: target.getTime() < Date.now() };
    }
    if (days === 1) {
        return { label: 'Domani', past: false };
    }
    if (days === -1) {
        return { label: 'Ieri', past: true };
    }
    return days > 0
        ? { label: `Tra ${days} giorni`, past: false }
        : { label: `${-days} giorni fa`, past: true };
}

export function isConvocationLink(value: string | undefined): boolean {
    return /^https?:\/\//i.test(value?.trim() ?? '');
}

export function convocationCityLine(c: ConvocationRowItem): string {
    const city = c.city?.trim();
    const province = c.province?.trim();
    if (city && province) {
        return `${city} (${province})`;
    }
    return city || province || '';
}

/** Uses the saved link when there is one, otherwise searches the address on Google Maps. */
export function convocationDirectionsUrl(c: ConvocationRowItem): string | null {
    if (isConvocationLink(c.linkPosition)) {
        return c.linkPosition.trim();
    }
    const query = [c.location, c.address, convocationCityLine(c)]
        .map((part) => part?.trim())
        .filter(Boolean)
        .join(', ');
    return query
        ? `https://www.google.com/maps/search/?api=1&query=${encodeURIComponent(query)}`
        : null;
}
